
export const generateName = (name) => {

    if ( name.length > 20 ) {
        return `${(name.substring(0, 20)).slice(0, -3)}...`;
    } else {
        return name;
    }
}